import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared';
import {CoreComponent} from './core.component';
import {NavbarComponent} from './components/navbar';
import {SidebarComponent} from './components/sidebar';
import {SidebarItemComponent} from './components/sidebar-item';
import {NavbarUserMenuComponent} from './components/navbar/navbar-user-menu';
import {ForbiddenComponent} from './components/forbidden/forbidden.component';
import {PasswordChangeComponent} from './components/password-change/password-change.component';

@NgModule({
    declarations: [
        CoreComponent,
        NavbarComponent,
        SidebarComponent,
        SidebarItemComponent,
        NavbarUserMenuComponent,
        ForbiddenComponent,
        PasswordChangeComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        HttpClientModule,
        RouterModule
    ],
    providers: [],
    exports: [
        CoreComponent,
        NavbarComponent
    ],
    entryComponents: [],
})

export class CoreModule {
}
